import { getFirebaseBackend } from '../../authUtils.js'

export const state = {
    currentUser: sessionStorage.getItem('authUser'),
    userAuthLevel: null,
    userRoles: null
}

export const mutations = {
    SET_CURRENT_USER(state, newValue) {
        state.currentUser = newValue
        saveState('auth.currentUser', newValue)
    },
    SET_USER_ACCESS_LEVEL(state, userLevels) {
        state.userRoles = userLevels;
        if(userLevels.includes('Admin')){
            state.userAuthLevel = true;
        }else{
            state.userAuthLevel = false;
        }
    }
}

export const getters = {
    // Whether the user is currently logged in.
    loggedIn(state) {
        return !!state.currentUser
        // return false;
    },
    userAuthorized(state){
        return !!state.userAuthLevel;
    }
}

export const actions = {
    // This is automatically run in `src/state/store.js` when the app
    // starts, along with any other actions named `init` in other modules.
    // eslint-disable-next-line no-unused-vars
    init({ state, dispatch }) {
        dispatch('validate')
    },

    // Logs in the current user.
    logIn({ commit, dispatch, getters }, { email, password } = {}) {
        if (getters.loggedIn) return dispatch('validate')

        return getFirebaseBackend().loginUser(email, password).then((response) => {
            const user = response
            commit('SET_CURRENT_USER', user)
            return user
        });
    },

    // Logs out the current user.
    logOut({ commit }) {
        // eslint-disable-next-line no-unused-vars
        commit('SET_CURRENT_USER', null)
        return new Promise((resolve, reject) => {
            // eslint-disable-next-line no-unused-vars
            getFirebaseBackend().logout().then((response) => {
                resolve(true);
            }).catch((error) => {
                reject(this._handleError(error));
            })
        });
    },

    // register the user
    // eslint-disable-next-line no-unused-vars
    resetPassword({ commit, dispatch, getters }, { email } = {}) {
        if (getters.loggedIn) return dispatch('validate')

        return getFirebaseBackend().forgetPassword(email).then((response) => {
            const message = response.data
            return message
        });
    },

    // Validates the current user's token and refreshes it
    // with new data from the API.
    // eslint-disable-next-line no-unused-vars
    async validate({ commit, state }) {
        if (!state.currentUser)return Promise.resolve(null)

        const user = await getFirebaseBackend().getAuthenticatedUser();
        const userLevels = await getFirebaseBackend().getAuthenticatedUsersAdminLevel(user);
        commit('SET_CURRENT_USER', user);
        commit('SET_USER_ACCESS_LEVEL', userLevels)
        
        if(user != null && (userLevels.includes('Admin'))){
            return true;
        }else{
            return false;
        }
        // return user;
    },
     // Validates the current user's token and refreshes it
    // with new data from the API.
    // eslint-disable-next-line no-unused-vars
    async getAccessLevels({ commit, state }) {
        if (!state.currentUser)return Promise.resolve(null)

        const user = await getFirebaseBackend().getAuthenticatedUser();
        const userLevels = await getFirebaseBackend().getAuthenticatedUsersAdminLevel(user);
        commit('SET_CURRENT_USER', user);
        commit('SET_USER_ACCESS_LEVEL', userLevels)
        
        return userLevels;

        // if(user != null && userLevels.includes('Mechanic')){
        //     return true;
        // }else{
        //     return false;
        // }
    },

    //function that will update the current user
    //this is called from the auth page to auto log in user.
    updateUserAuthState({commit}, {user}) {
        commit('SET_CURRENT_USER', user)
    },

    //this function is called from the auth page to see if the user can acess the admin panel.
    updateUserAuthAccess({commit}, {userLevels}) {
        commit('SET_USER_ACCESS_LEVEL', userLevels)
    },

}

// ===
// Private helpers
// ===

function saveState(key, state) {
    window.localStorage.setItem(key, JSON.stringify(state))
}